import * as React from 'react';
import ListItem from './ListItem';
import Sharer from './Sharer';

declare global {
  interface Window { dataLayer: any; googletag: any; adsbygoogle: any; ga: any; }
}

export interface ListProps {
  data: any[];
}

class List extends React.Component<ListProps> {

  public constructor(props: any) {

    super(props);
  }
  public render() {

    let counter = 0;
    return (
      <div className="list-wrapper">

        <Sharer title={'Stellenanbieter.de - Aktuelle Jobs'} url={document.location.href} />

        {this.getAd()}
        {this.initAd()}

        {this.props.data.map((item, keyIndex) => {

          counter++;

          if (counter % 4 === 0) {
            return (
              <span key={keyIndex}>
                <ListItem data={item} />
                {this.getAd()}
                {this.initAd()}
              </span>);
          } else {

            return (<ListItem data={item} key={keyIndex} />);
          }

        })}

        <div style={{ clear: 'both' }} />
      </div>
    );
  }

  private getAd() {

    return (
      <div className="full-block">
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-9629683982356381"
          data-ad-slot="4763578003"
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  private initAd() {

    setTimeout(
      () => {
        window.adsbygoogle.push({});
      },
      500);
    return (<span />);
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/List.tsx